import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createUnknownComponentVNode as _$cc, className as _$cn } from 'intact-vue';
import { Icon } from '../icon';
import { getRestProps } from '../utils';
import { Virtual } from '../virtual';
import { Transition } from 'intact-vue';
import { makeStyles } from './styles';
import { _$ } from '../../i18n';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    children = _this$get.children,
    className = _this$get.className;
  var _this$copy = this.copy,
    startCopy = _this$copy.startCopy,
    success = _this$copy.success;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-copy"] = true, _classNameObj[makeStyles(k)] = true, _classNameObj[className] = className, _classNameObj);
  return _$cc(Transition, {
    'name': 'k-fade',
    'children': _$cc(Virtual, _extends({
      'ev-click': startCopy,
      'className': _$cn(classNameObj)
    }, getRestProps(this), {
      'children': children ? children : !success.value ? _$cc(Icon, {
        'key': '1',
        'className': _$cn(k + "-icon-clone"),
        'hoverable': true,
        'title': _$('复制')
      }, '1') : _$cc(Icon, {
        'key': '2',
        'className': _$cn(k + "-icon-check"),
        'hoverable': true,
        'color': 'success'
      }, '2')
    }))
  });
}
;